(function () {
    'use strict';

    var serviceId = 'datacontext';
    angular.module('intro-app').factory(serviceId, ['$q', '$http', '_', datacontext]);

    function datacontext($q, $http, _) {
        var urlAPI = '/api';
        var _pageSize = 30;

        var service = {
            //-- ACCOUNT 
            account_login: account_login,
            account_get: account_get,
            account_changePassword: account_changePassword,
            account_recovery: account_recovery,
            account_newPassword: account_newPassword,
            account_register: account_register,
            account_activate: account_activate,
            account_resendMail: account_resendMail, 

            //-- UNITA ORGANIZZATIVA
            unitaOrganizzativa_getAllList: unitaOrganizzativa_getAllList,

            //-- SEGNALAZIONE
            segnalazione_getByCode: segnalazione_getByCode,
            segnalazione_get: segnalazione_get,
            segnalazione_add: segnalazione_add,
            segnalazione_update: segnalazione_update,
            segnalazione_delete: segnalazione_delete,

            //-- SEGNALAZIONE DTL
            segnalazioneDtl_getAllByFilter: segnalazioneDtl_getAllByFilter,
            segnalazioneDtl_get: segnalazioneDtl_get,
            segnalazioneDtl_add: segnalazioneDtl_add,
            segnalazioneDtl_update: segnalazioneDtl_update,
            segnalazioneDtl_addEditMultiplo: segnalazioneDtl_addEditMultiplo,
            segnalazioneDtl_delete: segnalazioneDtl_delete,

            //-- SEGNALAZIONE RISPOSTA
            segnalazioneRisposta_getAllByFilter: segnalazioneRisposta_getAllByFilter
        }

        return service;

        //-- ACCOUNT 
        function account_login(obj) {
            return $http.post(urlAPI + '/Account/Login', obj)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return response;
                });
        }

        function account_get() {
            return $http.get(urlAPI + '/account/get')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (response) {
                    return response;
                });
        }

        function account_changePassword(item) {
            return $http.post(urlAPI + '/account/ChangePassword', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return response;
                });
        }

        function account_recovery(item) {
            return $http.post(urlAPI + '/Account/Recovery', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return response;
                });
        }

        function account_newPassword(item) {
            return $http.post(urlAPI + '/Account/NewPassword', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return response;
                });
        }

        function account_register(item) {
            return $http.post(urlAPI + '/Account/Register', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return response;
                });
        }

        function account_activate(item) {
            return $http.post(urlAPI + '/Account/Activate', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return response;
                });
        }

        function account_resendMail(item) {
            return $http.post(urlAPI + '/Account/ResendMail', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return response;
                });
        }

        // ******************************
        //  UNITA ORGANIZZATIVA
        function unitaOrganizzativa_getAllList() {
            var data = getAllList('unitaOrganizzativa');
            return $q.when(data);
        }

        // ******************************
        //  SEGNALAZIONE
        function segnalazione_getByCode(codice, unitaId, order) {
            if (typeof (codice) == 'undefined') { codice = ''; }
            var params = [];
            params.push({ name: 'codice', value: codice });

            var data = getAllByParams('segnalazione', 'GetByCode', params);
            return $q.when(data);
        }

        function segnalazione_get(id) {
            var data = getById('segnalazione', id);
            return $q.when(data);
        }

        function segnalazione_add(item) {
            var data = addObj('segnalazione', item);
            return $q.when(data);
        }

        function segnalazione_update(item) {
            var data = updateObj('segnalazione', item);
            return $q.when(data);
        }

        function segnalazione_delete(id) {
            var data = deleteObj('segnalazione', id);
            return $q.when(data);
        }

        // ******************************
        //  SEGNALAZIONE DTL
        function segnalazioneDtl_getAllByFilter(segnalazioneId) {
            if (typeof (segnalazioneId) == 'undefined') { segnalazioneId = 0; }

            var params = [];
            params.push({ name: 'segnalazioneId', value: segnalazioneId });

            var data = getAllByParams('segnalazioneDtl', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function segnalazioneDtl_get(id) {
            var data = getById('segnalazioneDtl', id);
            return $q.when(data);
        }

        function segnalazioneDtl_add(item) {
            var data = addObj('segnalazioneDtl', item);
            return $q.when(data);
        }

        function segnalazioneDtl_update(item) {
            var data = updateObj('segnalazioneDtl', item);
            return $q.when(data);
        }

        function segnalazioneDtl_addEditMultiplo(segnalazioni) {
            var objName = 'segnalazioneDtl';
            var method = 'AddEditMultiplo';

            if (typeof (segnalazioni) == 'undefined') { segnalazioni = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            return $http.put(url, segnalazioni)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed AddEditMultiplo for %s: %s', objName, message);
                    return message.status;
                });
        }

        function segnalazioneDtl_delete(id) {
            var data = deleteObj('segnalazioneDtl', id);
            return $q.when(data);
        }

        // ******************************
        //  SEGNALAZIONE RISPOSTA
        function segnalazioneRisposta_getAllByFilter(codiceId) {
            if (typeof (codiceId) == 'undefined') { codiceId = 0; }

            var params = [];
            params.push({ name: 'codiceId', value: codiceId });

            var data = getAllByParams('segnalazioneRisposta', 'GetAllByFilter', params);
            return $q.when(data);
        }


        // ******************************
        //  Funzioni Generiche
        function getAll(objName) {
            return $http.get(urlAPI + '/' + objName + '/GetAll')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllList(objName) {
            return $http.get(urlAPI + '/' + objName + '/GetAllList')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllNoParam(objName, actionName) {
            var url = urlAPI + '/' + objName + '/' + actionName;
            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll NO Param for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllByParam(objName, actionName, paramName, paramValue) {
            var url = urlAPI + '/' + objName + '/' + actionName + '?' + paramName + '=' + paramValue;
            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllByParams(objName, actionName, paramArray) {
            var url = urlAPI + '/' + objName + '/' + actionName;

            var numParams = paramArray.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += paramArray[i].name + '=' + paramArray[i].value;
            }
            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllByParams for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getById(objName, id) {
            return $http.get(urlAPI + '/' + objName + '/Get/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getById for %s: %s', objName, message);
                    return message.status;
                });
        }

        function addObj(objName, objValue) {
            return $http.post(urlAPI + '/' + objName + '/Post', objValue)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        function updateObj(objName, objValue) {
            return $http.put(urlAPI + '/' + objName + '/Put', objValue)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed updateObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        function deleteObj(objName, id) {
            return $http.delete(urlAPI + '/' + objName + '/Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed deleteObj for %s: %s', objName, message);
                    return message.status;
                });
        }
        //  END - Funzioni Generiche
        // ******************************
    }
})();